namespace TabAurous.Reports {
    export interface UserRolesRow {
        UserRoleId?: number;
        UserId?: number;
        RoleId?: number;
    }

    export namespace UserRolesRow {
        export const idProperty = 'UserRoleId';
        export const localTextPrefix = 'Reports.UserRoles';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            UserRoleId = "UserRoleId",
            UserId = "UserId",
            RoleId = "RoleId"
        }
    }
}
